import React, { useState, Suspense } from 'react';
import useMeasure from 'react-use-measure';
import { AnimatePresence } from 'framer-motion6';
import BenefitIcon from '../BenefitIcon';
import { COVERAGE_ITEMS } from './consts';
import { BenefitIcons, BenefitInfo, BenefitContent } from './styled';

const CoverageSummary = () => {
  const [ref, { height }] = useMeasure();
  const [selectedBenefit, setSelectedBenefit] = useState(COVERAGE_ITEMS[0]);

  const openTravelMedical = () => {
    setSelectedBenefit(COVERAGE_ITEMS[0]);
  };

  return (
    <>
      <BenefitIcons>
        {COVERAGE_ITEMS.map((item) => (
          <BenefitIcon
            key={item.name}
            name={item.name}
            iconSrc={item.iconSrc}
            onClick={() => setSelectedBenefit(item)}
            isSelected={selectedBenefit.name === item.name}
          />
        ))}
      </BenefitIcons>
      <BenefitInfo animate={{ height: height || 'auto' }}>
        <AnimatePresence initial={false} exitBeforeEnter>
          <BenefitContent
            key={selectedBenefit.name}
            ref={ref}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <Suspense fallback={<div style={{ minHeight: 320 }}>Loading...</div>}>
              <selectedBenefit.Info openTravelMedical={openTravelMedical} />
            </Suspense>
          </BenefitContent>
        </AnimatePresence>
      </BenefitInfo>
    </>
  );
};

export default CoverageSummary;
